import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { Button, Divider, Grid, IconButton, Typography } from '@mui/material';
import { drawerRoute } from '../Data/Data'
import { Link, useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import '../Fonts/Kanit.css'
import '../Fonts/Fjalla.css'
import logo from '../Assests/pets.png'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import UserLogin from './UserLogin';
import UserSignUp from './UserSignUp';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import WarningIcon from '@mui/icons-material/Warning';


export default function Navbar() {
  const navigate = useNavigate();
  const [state, setState] = React.useState({
    left: false,
  });

  const [openDialog, setOpenDialog] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [iconChange, setIconChange] = React.useState(false)
  const [handleOpen, setHandleOpen] = React.useState(false);
  const [handleOpenSign, setHandleOpenSign] = React.useState(false);
  const [isLoggedIn, setIsLoggedIn] = React.useState(false);

  const token = sessionStorage.getItem('token');
  // const username = sessionStorage.getItem('username');
  const role = sessionStorage.getItem('role');
  const [username, setUsername] = React.useState('');

  React.useEffect(() => {
    // const username = sessionStorage.getItem('username'); // Or localStorage.getItem('username');

    // if (username) {
    //   setUsername(username);
    //   setIsLoggedIn(true);  // Set isLoggedIn to true if username exists
    // } else {
    //   setIsLoggedIn(false); // Ensure isLoggedIn is false if there's no username
    // }
    const storedPaws = JSON.parse(localStorage.getItem('paws'));

    if (storedPaws && storedPaws.username) {
      setUsername(storedPaws.username); // Set username from the stored 'paws' object
      setIsLoggedIn(true);  // Set isLoggedIn to true if username exists
    } else {
      setIsLoggedIn(false); // Set isLoggedIn to false if there's no username
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('paws');
    localStorage.removeItem('username');
    localStorage.removeItem('role');

    localStorage.clear(); // Clear session storage (or localStorage.clear() if using localStorage)
    window.location.reload();
  };

  const handleLogoutClick = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = (confirm) => {
    setOpenDialog(false);
    if (confirm) {
      handleLogout();
    }
  };

  function userLogin() {
    setHandleOpen(true);
  }
  function userSign() {
    setHandleOpenSign(true)
  }

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({
      ...state,
      [anchor]: open
    });

    setOpen(true)
  };

  const toggleDrawerClose = (anchor, close) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({
      ...state,
      [anchor]: close
    });
    setOpen(false)

  };

  const toggleDrawerOnClick = (anchor, close) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({
      ...state,
      [anchor]: close
    });
    setOpen(false)
    setIconChange(false)
  };

  const handleClick = () => {
    navigate("Login")
  }
  const handleClickLogout = () => {

    const result = window.confirm("Are you sure?");

    if (result) {
      //console.log("User clicked OK");
      localStorage.clear()
      window.location.reload()
      navigate("Login")
    }

  }

  const list = (anchor) => (
    <Box
      sx={{ width: 260, background: '#02847A', height: '100%', }}
      role="presentation"
      onClick={toggleDrawerOnClick(anchor, false)}
      onKeyDown={toggleDrawerOnClick(anchor, false)}
    >
        {username ? (
        <IconButton aria-label="menu open">
          <MenuOpenIcon onClick={toggleDrawerClose(anchor, false)} sx={{ color: 'white', fontSize: '40px' }} />
        </IconButton>

        ) :<>
        </>}
      <center>
        <a href='/'>

        <img
          src={logo}
          width='60%'
          height='auto'
          alt='companyLogo'
          draggable={false}
          />
          </a>
      </center>
      <Divider />

      {/* menu list view start */}
      <List
        sx={{
          maxHeight: 'calc(100vh - 150px)', // Adjust this to your preferred height
          overflowY: 'auto',
        }}>
        {drawerRoute.map((text, index) => (
          <ListItem key={index} disablePadding>
            <Link
              to={text.path}
              style={{
                textDecoration: 'none',
                color: 'black',
              }}
            >
              <ListItemButton sx={{ width: 250 }}>
                <ListItemIcon sx={{ color: 'white' }}>
                  {text.icon}
                </ListItemIcon>
                <ListItemText
                  primaryTypographyProps={{
                    color: 'white',
                    fontWeight: 'bold',
                    fontFamily: 'Kanit, sans-serif'
                  }}
                  primary={text.name}
                />
              </ListItemButton>
            </Link>
          </ListItem>
        ))}
      </List>
      {/* menu list view end */}

    </Box>
  );


  return (
    <div >
      {['left'].map((anchor) => (
        <React.Fragment key={anchor}>
          <Box sx={{ background: '#02847A', position: 'fixed', width: '100%', zIndex: '1', overflow: 'hidden' }}>
            <Grid container spacing={2}>
              <Grid item md={6} xs={6}>
              {username ? (
                <IconButton aria-label="menu open">
                  <MenuIcon onClick={toggleDrawer(anchor, true)} sx={{ color: 'white', fontSize: '40px' }} />
                </IconButton>
              ) : <></>}
              </Grid>
              <Grid item md={6} xs={6} sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', paddingRight: '1vw' }}>
                <Button
                  size="small"
                  variant="contained"
                  sx={{
                    // border: '0.3px white solid',
                    width: '250px',
                    borderRadius: '8px',
                    padding: '10px 30px',
                    // margin: '10px 10px',
                    textTransform: 'none',
                    // boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    transition: 'background-color 0.3s ease',
                    backgroundColor: isLoggedIn ? '#EA001D' : '#4CAF50', // Red for logout, green for login
                    '&:hover': {
                      backgroundColor: isLoggedIn ? '#EA001D' : '#388E3C', // Darker red/green on hover
                    },
                  }}
                  color="third"
                  startIcon={<AccountCircleIcon style={{ color: 'white' }} />}
                  onClick={() => {
                    isLoggedIn ? handleLogoutClick() : userLogin();
                  }}

                >

                  {isLoggedIn ? (
                    <span style={{ color: 'white', fontWeight: 'bold' }}>Logout | {username}</span>
                  ) : (
                    <span style={{ color: 'white', fontWeight: 'bold' }}>Login | User</span>
                  )}
                </Button>


                {/* <Button
                  size="large"
                  variant="contained"
                  sx={{
                    border: '0.3px white solid',
                    borderRadius: '8px',
                    padding: '10px 20px',
                    textTransform: 'none',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    transition: 'background-color 0.3s ease',
                    '&:hover': {
                      backgroundColor: '#FF5722',
                    },
                  }}
                  color="third"
                  startIcon={<AccountCircleIcon />}
                  onClick={() => userSign()}
                >
                  Sign Up | User
                </Button> */}

              </Grid>
            </Grid>
          </Box>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawerOnClick(anchor, false)}
            sx={{ height: '300px' }}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))
      }
      <UserLogin setHandleOpen={setHandleOpen} handelOpen={handleOpen} />
      <UserSignUp setHandleOpen={setHandleOpenSign} handelOpen={handleOpenSign} />

      {/* Confirmation Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle
          style={{
            backgroundColor: '#02847A',
            color: 'white',
            fontWeight: 'bold',
            fontSize: '1.5rem',
            textAlign: 'center',
            padding: '16px',
          }}
        >
          <WarningIcon style={{ fontSize: 30, marginRight: 10 }} />
          Are you sure you want to log out?
        </DialogTitle>

        <DialogActions style={{ justifyContent: 'center', padding: '16px' }}>
          <Button
            onClick={() => handleCloseDialog(false)}
            style={{
              fontWeight: 'bold',
              textTransform: 'none',
              borderRadius: '8px',
              padding: '10px 20px',
              backgroundColor: '#BDBDBD',
              color: 'white',
              marginRight: '10px',
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleCloseDialog(true)}
            style={{
              fontWeight: 'bold',
              textTransform: 'none',
              borderRadius: '8px',
              padding: '10px 20px',
              backgroundColor: '#D32F2F',
              color: 'white',
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>


      <UserLogin
        setHandleOpen={setHandleOpen}
        handelOpen={handleOpen}
      />
      <UserSignUp
        setHandleOpen={setHandleOpenSign}
        handelOpen={handleOpenSign}
      />
    </div >
  )
}
